import { Box, Button, Typography } from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'
import { useNavigate } from 'react-router-dom'

export const PageAuthorization = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        textAlign: 'center',
      }}
    >
      <LockIcon sx={{ fontSize: 64, color: 'text.disabled' }} />
      <Typography variant="h5" fontWeight={600}>
        Acesso não autorizado
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        Seu usuário não possui permissão para acessar esta página. Fale com o administrador do
        sistema caso precise deste acesso.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/dashboard')}>
        Voltar ao Dashboard
      </Button>
    </Box>
  )
}

export default PageAuthorization
